import { useQuery } from '@tanstack/react-query'

export interface MeritOrderStack {
  unit_id: string
  plant_id: string
  fuel_class: string
  srmc_pln: number
  capacity_mw: number
  cumulative_mw: number
}

export interface MeritOrderHour {
  hour: number
  clearing_price_pln: number
  actual_fix1_pln: number | null
  actual_fix2_pln: number | null
  gap_fix1_pln: number | null
  gap_fix2_pln: number | null
  residual_demand_mw: number
  total_available_mw: number
  marginal_unit_id: string | null
  marginal_fuel_class: string | null
  regime: string
}

export interface MeritOrderDispatch {
  date: string
  prices: { ttf_eur: number; ara_usd: number; eua_eur: number; eurpln: number }
  hours: MeritOrderHour[]
  stack: MeritOrderStack[]
}

async function fetchDispatch(date: string): Promise<MeritOrderDispatch> {
  const res = await fetch(`/api/merit-order/dispatch?date=${date}`, { credentials: 'include' })
  if (!res.ok) throw new Error(`Merit order dispatch failed (${res.status})`)
  return res.json()
}

export function useMeritOrderDispatch(date: string) {
  return useQuery({
    queryKey: ['merit-order-dispatch', date],
    queryFn: () => fetchDispatch(date),
    staleTime: 60_000,
  })
}
